<template>
  <b-overlay id="container-catalog">
  <div class="row">
    <div class="col-12">
        <b-card>
          <div
            class="accordion"
            id="accordionExample"
          >
            <div class="accordion-item">
              <div
                id="collapseOne"
                :class="collapseCatalog"
                aria-labelledby="headingOne"
                data-parent="#accordionExample"
              >
                <div class="row col-12">
                  <h3>Catálogos</h3>
                  <div style="right: 1px; position: absolute">
                    <b-button
                      pill
                      variant="primary"
                      size="sm"
                      @click="addObjectCatalog"
                    >
                      <b-icon icon="plus-circle-fill"/>
                      Agregar Catálogo
                    </b-button>
                  </div>
                </div>
                <div class="row col-12 mt-3 h-100">
                  <b-table
                    hover
                    :fields="listCatalogsField"
                    :items="arrayListCatalog"
                    select-mode="single"
                    selectable
                    @row-selected="onRowSelectedCatalog"
                  >
                    <template #cell(catalogName)="row">
                      <div v-if="row.item.catalogId !== 0">
                        <label>{{ row.item.catalogName }}</label>
                      </div>
                      <div v-else >
                        <b-form-input v-model="newCatalog" />
                        <div
                          class="form-label"
                          v-if="errorCatalog"
                        >
                          <div
                            class="alert alert-danger m-3"
                            role="role"
                          >
                            <b-icon
                              icon="exclamation-triangle-fill"
                            />
                            El nombre del catálogo no debe estar en blanco.
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(catalogState)="row">
                      <vs-chip
                        v-if="row.item.catalogState === materialState.ACTIVE"
                        title="Activo"
                      >
                        <vs-avatar icon="thumb_up" color="#26bd6a" />
                        Activo
                      </vs-chip>
                      <vs-chip
                        v-if="row.item.catalogState === materialState.INACTIVE"
                        title="Inactivo"
                      >
                        <vs-avatar icon="do_not_disturb" color="#DB1D2A" />
                        Inactivo
                      </vs-chip>
                    </template>
                    <template #cell(catalogServices)="row">
                      <vs-chip
                        v-for="service of row.item.catalogServices"
                        :key="service.id"
                        title="Servicio"
                        v-tooltip="'Servicio'"
                        class="mt-3"
                      >
                        <vs-avatar icon="description" color="#ff9f43" />
                        {{ service.nombre }}
                      </vs-chip>
                    </template>
                    <template #cell()="row">
                      <div class="row justify-content-end">
                        <template v-if="row.item.catalogName === ''">
                          <b-icon
                            class="m-2"
                            icon="check"
                            v-on:click.stop.prevent="pushCatalog(row.index)"
                          />
                          <b-icon
                            class="m-2"
                            icon="trash"
                            v-on:click="deleteArrayCatalog(row.index)"
                          />
                        </template>
                        <template v-if="row.item.catalogName !== ''">
                          <div v-tooltip="'Desplegar acciones'">
                            <b-dropdown
                              variant="link"
                              no-caret
                              right
                              data-cy="massive-actions"
                            >
                              <template #button-content>
                                <feather-icon
                                  data-cy="gear-button"
                                  width="24px"
                                  height="24px"
                                  icon="SettingsIcon"
                                  class="align-middle text-body"
                                />
                              </template>
                              <b-dropdown-item
                                @click="showModalChangeNameCatalog(row.item)"
                                data-cy="edit-name"
                              >
                                <vs-icon icon="edit"/>
                                Editar nombre
                              </b-dropdown-item>
                              <div>
                                <b-dropdown-item
                                  v-if="row.item.catalogState === materialState.ACTIVE"
                                  @click="changeStateCatalog(row.item)"
                                  data-cy="deactivate"
                                >
                                  <vs-icon icon="clear"/>
                                  Desactivar
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-else
                                  @click="changeStateCatalog(row.item)"
                                  data-cy="activate"
                                >
                                  <vs-icon icon="check"/>
                                  Activar
                                </b-dropdown-item>
                              </div>
                            </b-dropdown>
                          </div>
                        </template>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <div
                id="collapseTwo"
                :class="collapseCategory"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="row col-md-12">
                  <h3>Categorías</h3>
                  <div style="right: 1px; position: absolute">
                    <b-button
                      pill
                      variant="primary"
                      size="sm"
                      @click="addObjectCategory"
                    >
                      <b-icon icon="plus-circle-fill" />
                      Agregar Categoría
                    </b-button>
                  </div>
                </div>
                <div
                  class="row col-12 mt-3 justify-content-start"
                  v-if="selectedLinkCatalog.catalogName"
                  @click="collapseDiv('catalog')"
                >
                  <vs-chip
                    style="cursor: pointer;"
                    title="Volver a Catálogo"
                  >
                    <vs-avatar icon="arrow_back" color="#26bd6a" />
                    Volver a Catálogo
                  </vs-chip>
                </div>
                <div class="row col-md-12 mt-3">
                  <div
                    v-on:click="collapseDiv('catalog')"
                    class="text-border-shadow"
                  >
                    <label class="h-100 m-3 text-rotate-vertical" role="button">
                      {{ "Catálogo : " + selectedLinkCatalog.catalogName }}
                      <b-icon
                        icon="caret-left-fill"
                        width="20"
                        height="20"
                      />
                    </label>
                  </div>
                  <b-table
                    class="col-md-11 h-100 ml-3"
                    hover
                    :fields="listCategorysField"
                    :items="catalogFiltered(category)"
                    select-mode="single"
                    selectable
                    @row-selected="onRowSelectedCategory"
                  >
                    <template #cell(descripcion)="row">
                      <div v-if="row.item.opcionId !== 0">
                        <label>{{ row.item.descripcion }}</label>
                      </div>
                      <div v-else >
                        <select
                          type="select"
                          class="form-control"
                          v-model="newCategory"
                          v-validate="'required'"
                          name="Categoría"
                        >
                          <option disabled v-bind:value="[{
                              opcionId: 0,
                              descripcion: ''
                            }]">
                          </option>
                          <option
                            v-for="option in listCategorys"
                            v-bind:value="[{
                              opcionId: option.categoryId,
                              descripcion: option.categoryName
                            }]"
                            v-bind:key="option.categoryId"
                          >
                            {{ option.categoryName }}
                          </option>
                        </select>
                        <div
                          class="form-label"
                          v-if="errorCategory"
                        >
                          <div
                            class="alert alert-danger m-3"
                            role="role"
                          >
                            <b-icon
                              icon="exclamation-triangle-fill"
                            />
                            La categoría no debe estar en blanco.
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell()="row">
                      <div class="row justify-content-end">
                        <b-icon
                          v-if="row.item.opcionId === 0"
                          class="m-2"
                          icon="check"
                          data-cy="push-category-array"
                          @click="pushCategoryCatalog(row.index)"
                        />
                        <b-icon
                          class="m-2"
                          icon="trash"
                          data-cy="delete-category-array"
                          @click="deleteArrayCategory(row.index)"
                        />
                      </div>
                    </template>
                  </b-table>
                </div>
              </div >
            </div>
            <div class="accordion-item">
              <div
                id="collapseThree"
                :class="collapseMaterial"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="row col-12">
                  <h3>Materiales</h3>
                  <div style="right: 1px; position: absolute">
                    <b-button
                      pill
                      variant="primary"
                      size="sm"
                      @click="addObjectMaterial"
                    >
                      <b-icon icon="plus-circle-fill" />
                      Agregar Material
                    </b-button>
                  </div>
                </div>
                <div
                  class="row col-12 mt-3 justify-content-start"
                  @click="collapseDiv('category')"
                >
                  <vs-chip
                    style="cursor: pointer;"
                    title="Volver a Categoría"
                  >
                    <vs-avatar icon="arrow_back" color="#26bd6a" />
                    Volver a Categoría
                  </vs-chip>
                </div>
                <div class="row col-12 mt-3">
                  <div
                    v-on:click="collapseDiv('catalog')"
                    class="text-border-shadow"
                  >
                    <label class="h-100 m-3 text-rotate-vertical" role="button">
                      {{ "Catálogo : " + selectedLinkCatalog.catalogName }}
                      <b-icon
                        icon="caret-left-fill"
                        width="20"
                        height="20"
                      />
                    </label>
                  </div>
                  <div
                    v-on:click="collapseDiv('category')"
                    class="text-border-shadow"
                  >
                    <label class="h-100 m-3 text-rotate-vertical" role="button">
                      {{ "Categoría: " + selectedLinkCategory }}
                      <b-icon
                        icon="caret-left-fill"
                        width="20"
                        height="20"
                      />
                    </label>
                  </div>
                  <div class="col-11">
                    <b-table
                      hover
                      :fields="listMaterialsField"
                      :items="catalogFiltered(material)"
                    >
                      <template  #cell(nameMaterial)="row">
                        {{ row.item.nameMaterial }}
                      </template>
                      <template  #cell(brandMaterial)="row">
                        {{ row.item.brandMaterial.descripcion }}
                      </template>
                      <template #cell(priceMaterial)="row">
                        {{ parseInt(row.item.priceMaterial) | toCurrency }}
                      </template>
                      <template #cell(quantityMaterial)="row">
                        <b-form-input
                          type="number"
                          class="w-100"
                          v-model.number="row.item.quantityMaterial"
                          data-vv-as="Cantidad"
                          name="cantidad"
                          v-validate="`required|numeric|min_value:1|max_value:${quantityMax}`"
                          @change="validQuantity(row)"
                        />
                      </template>
                      <template #cell()="row">
                        <div class="row justify-content-end">
                          <b-icon
                            class="m-2"
                            icon="trash"
                            v-on:click="deleteArrayMaterial(row.index)"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <div v-if="newRegister" class="row col-12 mt-3 justify-content-end">
                <b-button variant="primary" class="ml-2" @click="cancelCatalog">
                  Cancelar Catálogo
                </b-button>
                <template v-if="catalogState === 'new'">
                  <b-button variant="primary" class="ml-2" @click="saveNewCatalog">
                    Guardar Catálogo
                  </b-button>
                </template>
                <template v-if="catalogState === 'edit'">
                  <b-button variant="primary" class="ml-2" @click="saveEditCatalog">
                    Editar Catálogo
                  </b-button>
                </template>
              </div>
              <PopUpAddFromUnity
                whoCall="catalog"
                @reload="pushMaterialCatalog"
                :materialObject="arrayMaterial"
              >
              </PopUpAddFromUnity>
            </div>
          </div>
        </b-card>
      <b-modal
        id="edit-catalog-name"
        ref="editCatalogName"
        title="Editar Nombre"
        hide-footer
        no-close-on-backdrop
      >
        <div class="row mb-5">
          <div class="col-md-12 mt-3">
            <label>Nombre</label>
            <input
              class="form-control"
              v-model="selectedLinkCatalog.catalogName"
            >
          </div>
          <div class="col-md-12 mt-3">
            <div style="float: right">
              <b-button
                variant="primary"
                @click="changeNameCatalog()"
              >
                <b-icon icon="folder" />
                Guardar
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PopUpAddFromUnity from '@/febos/global/materialsRequests/vistas/modals/PopUpAddFromUnity';
import MaterialProcessState from '@/febos/global/materialsRequests/mixins/MaterialProcessState';

export default {
  name: 'CatalogsMaintenance',
  components: {
    PopUpAddFromUnity
  },
  data() {
    return {
      materialState: MaterialProcessState,
      catalog: 'catalog',
      category: 'category',
      material: 'material',
      errorCatalog: false,
      errorCategory: false,
      newRegister: false,
      newCatalog: '',
      newCategory: '',
      selectedLinkCatalog: {},
      selectedLinkCategory: '',
      nameCard: 'Catálogo',
      catalogState: '',
      quantityMax: 100,
      collapseCatalog: 'accordion-collapse collapse show',
      collapseCategory: 'accordion-collapse collapse',
      collapseMaterial: 'accordion-collapse collapse',
      arrayListCatalog: [],
      listCatalogsField: [
        { key: 'catalogName', label: 'Catálogos' },
        { key: 'catalogState', label: 'Estado' },
        { key: 'catalogServices', label: 'Servicios' },
        { key: 'actions', label: '' }
      ],
      listCategorysField: [
        { key: 'descripcion', label: 'Categorías' },
        { key: 'actions', label: '' }
      ],
      listMaterialsField: [
        { key: 'nameMaterial', label: 'Nombre Material' },
        { key: 'brandMaterial', label: 'Marca' },
        { key: 'priceMaterial', label: 'Precio Unitario' },
        { key: 'quantityMaterial', label: 'Cantidad' },
        { key: 'actions', label: '' }
      ],
    };
  },
  mounted() {
    this.searchListCatalogOrigin();
    this.loadListCategory();
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#container-catalog > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#container-catalog',
        scale: 0.6
      });
    }
  },
  computed: {
    ...mapGetters('Materials', [
      'loading',
      'listCatalogs',
      'listCategorys',
      'listBrands',
      'arrayMaterial'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('Materials', [
      'loadListCatalogs',
      'loadListCategory',
      'addNewCatalog',
      'editCatalog'
    ]),
    notify(message) {
      this.$bvToast.toast(
        message,
        {
          title: '¡Oops!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
    },
    validQuantity(value) {
      this.searchNewEdit();
      if (value.item.quantityMaterial < 0) {
        this.notify('Cantidad no puede ser negativo');
      }
      if (value.item.quantityMaterial > 100) {
        this.notify(`Cantidad no puede ser mayor a ${this.quantityMax}`);
      }
    },
    searchNewEdit() {
      this.newRegister = true;
      this.newCatalog = '';
      this.errorCatalog = false;
      this.catalogState = this.selectedLinkCatalog.catalogId === 0 ? 'new' : 'edit';
    },
    addObjectCatalog() {
      if (this.catalogState === '') {
        this.newRegister = true;
        this.newCatalog = '';
        this.errorCatalog = false;
        this.catalogState = 'new';
        this.arrayListCatalog.unshift({
          catalogId: 0,
          catalogName: '',
          catalogCategorys: [],
          catalogMaterials: []
        });
      }
    },
    addObjectCategory() {
      if (!this.arrayListCatalog.includes((x) => x.opcionId === 0)) {
        this.searchNewEdit();
        return this.arrayListCatalog
          .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
          .map((row) => row.catalogCategorys.unshift({
            catalogId: this.selectedLinkCatalog.catalogId,
            descripcion: '',
            opcionId: 0
          }));
      }
      return [];
    },
    addObjectMaterial() {
      if (this.selectedLinkCatalog.catalogId !== 0) {
        this.searchNewEdit();
        this.arrayMaterial.catalogId = this.selectedLinkCatalog.catalogId;
      }
      this.showModals('PopUpAddFromUnity');
    },
    pushCatalog(index) {
      if (this.newCatalog.length > 0) {
        this.errorCatalog = false;
        this.arrayListCatalog.splice(index, 1,
          {
            catalogId: 0,
            catalogName: this.newCatalog,
            catalogCategorys: [],
            catalogMaterials: [],
            estado: this.materialState.ACTIVE
          });
        this.onRowSelectedCatalog([
          {
            catalogName: this.newCatalog,
            catalogId: 0
          }
        ]);
      } else {
        this.errorCatalog = true;
      }
    },
    pushCategoryCatalog(index) {
      if (this.newCategory.length > 0) {
        if (this.arrayListCatalog
          .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
          .some((category) => category.catalogCategorys
            .some((row) => row.descripcion === this.newCategory[0].descripcion))) {
          this.notify('La categoría que intentas agregar ya existe.');
          return;
        }
        this.errorCategory = false;
        this.arrayListCatalog
          .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
          .map((row) => row.catalogCategorys.splice(index, 1,
            {
              catalogId: this.selectedLinkCatalog.catalogId,
              descripcion: this.newCategory[0].descripcion,
              opcionId: this.newCategory[0].opcionId,
            }));

        this.onRowSelectedCategory({
          catalogId: this.selectedLinkCatalog.catalogId,
          descripcion: this.newCategory[0].descripcion,
          opcionId: this.newCategory[0].opcionId
        });
      } else {
        this.errorCategory = true;
      }
    },
    pushMaterialCatalog(materials) {
      return this.arrayListCatalog
        .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
        .map(
          (row) => {
            materials.map((item) => {
              if (row.catalogMaterials
                .findIndex((e) => e.nameMaterial === item.nameMaterial) === -1) {
                row.catalogMaterials.push(item);
              }
              return item;
            }); return row;
          }
        );
    },
    cancelCatalog() {
      this.clearData();
      this.chargeListCatalogOrigin();
    },
    objectNewCatalog(data) {
      return {
        descripcion: data.catalogName,
        categorias: (data.catalogCategorys || []),
        materiales: (data.catalogMaterials || [])
          .map((obj) => ({
            categoria: obj.categoryMaterial,
            marca: obj.brandMaterial,
            nombre: obj.nameMaterial,
            precio: obj.priceMaterial,
            SKU: obj.skuMaterial,
            cantidad: obj.quantityMaterial,
            moneda: 'CLP'
          })),
        estado: this.materialState.ACTIVE
      };
    },
    objectEditCatalog(data, state, newName = '') {
      return {
        id: data.catalogId,
        query: {
          descripcion: (newName !== '' ? newName : data.catalogName),
          categorias: (data.catalogCategorys || []),
          materiales: (data.catalogMaterials || [])
            .map((obj) => ({
              categoria: obj.categoryMaterial,
              marca: obj.brandMaterial,
              nombre: obj.nameMaterial,
              precio: obj.priceMaterial,
              SKU: obj.skuMaterial,
              cantidad: obj.quantityMaterial,
              moneda: 'CLP'
            })),
          estado: state
        }
      };
    },
    deleteArrayCatalog(index) {
      this.arrayListCatalog.splice(index, 1);
      this.searchNewEdit();
    },
    deleteArrayCategory(index) {
      const ind = this.arrayListCatalog
        .findIndex((data) => data.catalogId === this.selectedLinkCatalog.catalogId);
      if (ind !== -1) {
        this.arrayListCatalog[ind].catalogCategorys.splice(index, 1);
      }
      this.searchNewEdit();
    },
    deleteArrayMaterial(index) {
      const ind = this.arrayListCatalog
        .findIndex((data) => data.catalogId === this.selectedLinkCatalog.catalogId);
      if (ind !== -1) {
        this.arrayListCatalog[ind].catalogMaterials.splice(index, 1);
      }
      this.searchNewEdit();
    },
    async searchListCatalogOrigin() {
      const query = {
        params: {
          tipo: 'catalogos',
          campos: '*',
          filtros: ''
        }
      };
      await this.loadListCatalogs(query);
      this.chargeListCatalogOrigin();
    },
    async saveNewCatalog() {
      const catalog = this.arrayListCatalog
        .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
        .map((row) => this.objectNewCatalog(row))[0];
      if (catalog.materiales
        .find((data) => data.cantidad < 0 || data.cantidad > this.quantityMax)) {
        this.notify(`Cantidad no puede ser negativo y no puede ser mayor a ${this.quantityMax}`);
        return;
      }
      await this.addNewCatalog(catalog);
      this.clearData();
      this.searchListCatalogOrigin();
    },
    async saveEditCatalog() {
      const catalog = this.arrayListCatalog
        .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
        .map((row) => this.objectEditCatalog(row, this.materialState.ACTIVE))[0];
      if (catalog.query.materiales
        .find((data) => data.cantidad < 0 || data.cantidad > this.quantityMax)) {
        this.notify(`Cantidad no puede ser negativo y no puede ser mayor a ${this.quantityMax}`);
        return;
      }
      await this.editCatalog(catalog);
      this.clearData();
      this.searchListCatalogOrigin();
    },
    async changeStateCatalog(index) {
      const state = index.catalogState === this.materialState.ACTIVE
        ? this.materialState.INACTIVE : this.materialState.ACTIVE;
      const catalog = this.objectEditCatalog(index, state);
      await this.editCatalog(catalog);
      this.clearData();
      this.searchListCatalogOrigin();
    },
    async changeNameCatalog() {
      const catalog = this.objectEditCatalog(
        this.selectedLinkCatalog.catalog,
        this.selectedLinkCatalog.catalog.catalogState,
        this.selectedLinkCatalog.catalogName
      );
      await this.editCatalog(catalog);
      this.$refs.editCatalogName.hide();
      this.clearData();
      this.searchListCatalogOrigin();
    },
    async showModalChangeNameCatalog(item) {
      this.listCategoryCatalog = [];
      this.selectedLinkCatalog = { ...item, catalog: item };
      this.$refs.editCatalogName.show();
    },
    onRowSelectedCatalog(items) {
      if (items.length !== undefined && items.length > 0) {
        if (items[0].catalogName === '') return;
        this.listCategoryCatalog = [];
        this.selectedLinkCatalog = {
          catalogName: items[0].catalogName,
          catalogId: items[0].catalogId
        };
        this.collapseDiv(this.category);
      }
    },
    onRowSelectedCategory(items) {
      if (items.length > 0) {
        if (items[0].opcionId === 0) {
          return;
        }
        this.selectedLinkCategory = items[0].descripcion;
        this.collapseDiv(this.material);
      }
    },
    catalogFiltered(page) {
      return this.arrayListCatalog
        .filter((data) => data.catalogId === this.selectedLinkCatalog.catalogId)
        .map((row) => {
          if (page === this.category) return row.catalogCategorys;
          if (page === this.material) return row.catalogMaterials;
          return row;
        })[0];
    },
    collapseDiv(item) {
      if (item === this.catalog) {
        if (this.catalogState === '') {
          this.nameCard = 'Catálogo';
          this.collapseCatalog = 'accordion-collapse collapse show';
          this.collapseCategory = 'accordion-collapse collapse';
          this.collapseMaterial = 'accordion-collapse collapse';
        } else {
          this.notify('Antes de volver a catálogo debe terminar con los cambios.');
        }
      }
      if (item === this.category) {
        this.nameCard = 'Categoría';
        this.collapseCatalog = 'accordion-collapse collapse';
        this.collapseCategory = 'accordion-collapse collapse show';
        this.collapseMaterial = 'accordion-collapse collapse';
      }
      if (item === this.material) {
        this.nameCard = 'Materiales';
        this.collapseCatalog = 'accordion-collapse collapse';
        this.collapseCategory = 'accordion-collapse collapse';
        this.collapseMaterial = 'accordion-collapse collapse show';
      }
    },
    chargeListCatalogOrigin() {
      this.arrayListCatalog = [];
      this.listCatalogs.forEach((data) => {
        this.arrayListCatalog.push({
          catalogId: data.catalogId,
          catalogName: data.catalogName,
          catalogCategorys: (data.catalogCategorys || []).map((item) => ({
            catalogId: data.catalogId,
            opcionId: item.opcionId,
            descripcion: item.descripcion
          })),
          catalogMaterials: (data.catalogMaterials || []).map((item) => ({
            catalogId: data.catalogId,
            categoryMaterial: item.categoria,
            brandMaterial: item.marca,
            nameMaterial: item.nombre,
            priceMaterial: item.precio,
            skuMaterial: item.SKU,
            quantityMaterial: item.cantidad || 0,
            imageMaterial: '',
            currencyMaterial: 'CLP'
          })),
          catalogState: data.catalogState
        });
      });
    },
    clearData() {
      this.newRegister = false;
      this.errorCatalog = false;
      this.errorCategory = false;
      this.selectedLinkCatalog = {};
      this.selectedLinkCategory = '';
      this.arrayListCatalog = [];
      this.newCatalog = '';
      this.newCategory = '';
      this.nameCard = 'Catálogo';
      this.catalogState = '';
      this.collapseDiv(this.catalog);
    }
  }
};
</script>
<style>
  .text-border-shadow {
    height: 400px;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
  }
  .text-rotate-vertical {
    text-align: right;
    margin-left: 10px;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
  }
</style>
